/**
 * Viewport queries shared by the Stimulus controllers.
 *
 * The value mirrors $breakpoint-m in the stylesheets. It is stated in `em` on
 * purpose: with `px` the JS boundary would stay put while the CSS one moves as
 * soon as a reader raises their browser font size, and the two would disagree
 * about which layout is on screen.
 */
export const MOBILE_QUERY = "(max-width: 50em)";
